export default __webpack_public_path__ + "static/media/Products_Image_03.30b55397.png";